import React, { FC, useRef } from 'react'

interface IProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> {
  value: string
  onChange: (value: string) => void
}

const formatDateInput = (raw: string): string => {
  const digits = raw.replace(/\D/g, '').slice(0, 8)
  if (digits.length <= 2) return digits
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
}

export const DateInput: FC<IProps> = ({ value, onChange, placeholder = 'DD/MM/YYYY', ...rest }) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const el = e.target
    const cursorPos = el.selectionStart ?? el.value.length
    const digitsBeforeCursor = el.value.slice(0, cursorPos).replace(/\D/g, '').length

    const newValue = formatDateInput(el.value)
    onChange(newValue)

    requestAnimationFrame(() => {
      if (!inputRef.current) return
      let newCursorPos = 0
      if (digitsBeforeCursor > 0) {
        let found = 0
        for (let i = 0; i < newValue.length; i++) {
          if (/\d/.test(newValue[i])) found++
          if (found === digitsBeforeCursor) {
            newCursorPos = i + 1
            break
          }
        }
        if (found < digitsBeforeCursor) newCursorPos = newValue.length
      }
      inputRef.current.setSelectionRange(newCursorPos, newCursorPos)
    })
  }

  return (
    <input
      ref={inputRef}
      type='text'
      value={value}
      placeholder={placeholder}
      onChange={handleChange}
      {...rest}
    />
  )
}
